import { MenuList } from './MenuList';
import { MenuListItem as Item } from './MenuListItem';
MenuList.displayName = "MenuListBase";
Item.displayName = "MenuList.Item";
export { MenuList as default, Item };